/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { LazyForPaintBackgroundScripts } from '@jira/global-pages__dashboard-background-scripts/src/async.tsx';
import type { LazyComponent } from '@atlassian/react-loosely-lazy';

export const DashboardBackgroundScripts: LazyComponent<() => React.JSX.Element> =
	LazyForPaintBackgroundScripts;
